import React from 'react';
import { Link } from 'react-router-dom';
import API from '../../servicios/api';

class ListaFamiliares extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            datosCargados:false,
            empleado_docId: "",
            empleado_claveAPI: "",
            familiares: [],
            errores: [],
            serverror: ""
         };
    }

    editarDatos = (id) => {
        console.log(id);
        fetch(API + "?qfamiliaresbyId="+id)
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            console.log(datos);
        })
        .catch(console.log)
    }
    borrarDatos = (id) => {
        fetch(API + "?borrarFamiliar="+id)
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            if (datos.success && datos.success===1){
                this.cargarDatos(this.state.empleado_claveAPI, this.state.empleado_docId);
            } else{
                this.setState({serverror:datos.error});
            }
            
        })
        .catch(console.log)
    }

    componentDidMount(){
        const k = this.props.match.params.claveapi_docId; 
        const keyAPI = k.split('_')[0]; 
        const docId = k.split('_')[1];
        this.cargarDatos(keyAPI, docId);
    }
    cargarDatos = (keyAPI, docId) => {
        this.setState({empleado_docId: docId, empleado_claveAPI: keyAPI});
        fetch(API +"?qfamiliaresKeyAPI", {
            method:"POST",
            body: JSON.stringify({claveAPI:keyAPI})
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.error && datos.error!==""){
                this.setState({serverror:datos.error});
            } else if (datos.length>0){
                // Format some values
                this.setState({ 
                    datosCargados:true,
                    familiares: datos
                });
            } else {
                this.setState({ 
                    datosCargados:true,
                    familiares: []
                });
            }
        })
        .catch(console.log)
    }

    render() { 
        const {  datosCargados, empleado_claveAPI, empleado_docId, familiares, serverror } = this.state;
        
        if (!datosCargados) {
            return(<div><div className="spinner-border text-success"></div>Cargando datos de familiares del familiares...</div>);
        } else if (datosCargados && familiares.length===0){
                return (<div>No hay registros
                    <div className="">
                        <Link to={"/addfamiliares/"+empleado_claveAPI+"_"+empleado_docId} className="btn btn-success btn-w">Agregar nuevo familiar</Link>
                    </div>

                    <hr width="100%" />
                <br></br>
                <div className="btn-group btn-acciones" aria-label="">
                    <div className='btn-size-sm'><Link to={"/perfil4/" + empleado_claveAPI} className="btn btn-warning btn-size-sm">Atras</Link></div>
                    <div><button type="button" className="btn btn-success">Finalizar</button></div>
                </div>
                </div>);
        } else {
                return ( 
            <div className="card">
                <div className="card-header">
                    <div className='encuesta-title'>
                        <div><strong>FAMILIARES</strong></div>
                        <div>5 de 5</div>
                    </div>
                </div>
                <div className="card-body">
                    <h5 className="card-title">Lista de Familiares</h5>
                    <div className="table-responsive-sm">
                        <table className="table table-sm table-hover table-striped table-familiares">
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>docId</th>
                                    <th>Nombre</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    familiares.map(
                                        (familiar) => (
                                            <tr key={familiar.id}>
                                                <td>{familiar.id}</td><td>{familiar.docId}</td>
                                                <td>{familiar.nombre}</td>
                                                <td>
                                                    <div className="btn-group" role="group" aria-label="">
                                                        <Link to={"/editarFamiliar/" + familiar.id} className="btn btn-outline-warning btn-sm">Editar</Link>
                                                        <button type="button" onClick={() => this.borrarDatos(familiar.id)} className="btn btn-outline-danger btn-sm">Borrar</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    )

                                }

                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="server-error">{serverror}</div>


                <div className="card-footer text-muted">
                    <Link to={"/addfamiliares/"+empleado_claveAPI+"_"+empleado_docId} className="btn btn-success">Agregar nuevo familiar</Link>
                
                
                </div>


                <hr width="100%" />
                <br></br>
                <div className="btn-group btn-acciones-final">
                    <div className="btn-group btn-acciones" aria-label="">
                        <div className='btn-size-sm'><Link to={"/perfil4/" + empleado_claveAPI} className="btn btn-warning btn-size-sm">Atras</Link></div>
                        {/* <div><button type="button" className="btn btn-success">Finalizar</button></div> */}
                        <div className='btn-size-sm'><Link to={"/fin/"} className="btn btn-primary btn-size-sm">Finalizar</Link></div>
                    </div>
                </div>
                
            </div>
        );
        }
    }
}

export default ListaFamiliares;